export function statusColor(status) {
  switch (status) {
    case "draft":
      return "#333";
    case "to_be_approved":
      return "#EDB526";
    case "publish_scheduled":
      return "#8757D6";
    case "published":
      return "#66D184";
    case "invite_scheduled":
      return "#3F7DDA";
    case "invited":
      return "#66D184";
    case "canceled":
      return "#999999";
    case "archived":
      return "#98673A";
    default:
      break;
  }
}

export function statusText(status) {
  switch (status) {
    case "draft":
      return "Draft";
    case "to_be_approved":
      return "To Be Approved";
    case "publish_scheduled":
      return "Scheduled For Publish";
    case "published":
      return "Published";
    case "invite_scheduled":
      return "Scheduled For Invite";
    case "invited":
      return "Invited";
    case "canceled":
      return "Canceled";
    case "archived":
      return "Archived";
    default:
      break;
  }
}
